import { cn } from "@workspace/ui/lib/utils";

import { MoneyText } from "./money";
import { useAllCurrenciesContent } from "./use-all-currencies-content";

export function AllCurrenciesContent({
	value = 0,
	className,
	currency,
}: {
	value?: number | null | undefined;
	className?: string;
	currency?: string;
}) {
	const { currencyRates } = useAllCurrenciesContent({ value, currency });

	return (
		<>
			{currencyRates.map((item) => (
				<div className={cn("flex gap-2", className)} key={item.toCurrency}>
					<span>{item.code}</span>
					<MoneyText
						key={item.toCurrency}
						value={item.convertedValue}
						currency={item.toCurrency}
					/>
				</div>
			))}
		</>
	);
}
